module.exports = __webpack_public_path__ + "static/media/i-share.d61d34a0.gif";